import { AfterViewInit, Component } from '@angular/core';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';

@Component({
  selector: 'expired-virtual-binder',
  templateUrl: './expired-virtual-binder.component.html',
  styleUrls: ['./expired-virtual-binder.component.scss', '../../stylesheets/job-main.scss']
})
export class ExpiredVirtualBinderComponent implements AfterViewInit {

  constructor() { }

  ngAfterViewInit(): void {
		setTimeout(() => {
			GlobalSettingsService.isGlobalLoaderLoading = false;
			GlobalSettingsService.isSecondaryLoaderLoading = false;
		}, 0);
	}

}
